import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function CoinInHand(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M17.191 4.15504H15.523C15.2666 4.15394 15.0178 4.24247 14.8198 4.40533C14.6217 4.56818 14.4867 4.79513 14.4382 5.04694C14.3897 5.29875 14.4307 5.55959 14.5541 5.78438C14.6775 6.00917 14.8756 6.18379 15.114 6.27804L16.807 6.95504C17.0447 7.04965 17.242 7.22414 17.3649 7.44849C17.4878 7.67284 17.5287 7.93301 17.4805 8.18424C17.4323 8.43547 17.2981 8.66206 17.1009 8.82501C16.9037 8.98795 16.6559 9.07708 16.4 9.07704H14.73'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M15.9611 4.15501V2.96301'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M15.9611 10.141V9.07703'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M10.321 6.61595C10.321 8.11177 10.9153 9.54633 11.973 10.604C13.0307 11.6617 14.4652 12.2559 15.961 12.2559C17.4569 12.2559 18.8914 11.6617 19.9491 10.604C21.0068 9.54633 21.601 8.11177 21.601 6.61595C21.601 5.12013 21.0068 3.68558 19.9491 2.62787C18.8914 1.57017 17.4569 0.975952 15.961 0.975952C14.4652 0.975952 13.0307 1.57017 11.973 2.62787C10.9153 3.68558 10.321 5.12013 10.321 6.61595Z'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M15.2 17.42L21.417 15.434L21.46 15.422C21.8097 15.3454 22.1754 15.3986 22.4887 15.5718C22.802 15.745 23.0416 16.0263 23.1627 16.3632C23.2838 16.7 23.2782 17.0695 23.1469 17.4025C23.0155 17.7356 22.7675 18.0094 22.449 18.173C10.312 24 13.408 24 0.749023 19.956'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M0.75 12.256H2.95C5.50711 12.2299 7.98773 13.1276 9.936 14.784L9.977 14.82H14.077C14.486 14.82 14.8782 14.9824 15.1674 15.2716C15.4565 15.5608 15.619 15.953 15.619 16.362C15.6193 16.7697 15.458 17.161 15.1705 17.4502C14.8831 17.7393 14.4927 17.9029 14.085 17.905L7.851 17.936'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </BaseLibraryIconSvg>
  );
}
